import { useCallback, useEffect, DependencyList } from "react";

// debounce: performs effect after delay only (e.g. to wait if user is typing)
export const useDebouncedEffect = (
  effect: () => void,
  delay: number,
  deps: DependencyList
): void => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const callback = useCallback(effect, deps);

  useEffect(() => {
    const handler = setTimeout(() => {
      callback();
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [callback, delay]);
};
